// BUILD-046 section C (Owner direction of 2026-10-21): dictation for the Update note, reusing what HQ already has.
//
// HQ dictation is the browser built-in speech recognition (ChatPage.tsx toggleVoiceInput: SpeechRecognition / webkitSpeechRecognition, English US, continuous with interim
// results). It costs nothing, needs no provider and no key, and sends nothing to this application: the browser itself listens. This module is the same capability as two small
// pure functions (is it there, and how the spoken text joins the text already typed) so the Update form can offer a microphone WITHOUT copying the logic into the page. The
// microphone is shown only where the browser has the capability; nothing is faked where it does not. ChatPage.tsx is left as it is.
//
// Pure module. Erasable TypeScript only.

/** The constructor of the browser speech recognition, or null where the browser has none. `scope` defaults to the window. */
export function recognitionOf(scope?: unknown): (new () => unknown) | null {
  const host = (scope ?? (typeof window !== "undefined" ? window : undefined)) as { SpeechRecognition?: unknown; webkitSpeechRecognition?: unknown } | undefined;
  if (host === undefined || host === null) return null;
  const found = host.SpeechRecognition ?? host.webkitSpeechRecognition;
  return typeof found === "function" ? (found as new () => unknown) : null;
}

/** True where the browser can dictate. */
export function dictationSupported(scope?: unknown): boolean {
  return recognitionOf(scope) !== null;
}

/** The text after dictating: what was typed before the microphone started, a single space, then everything spoken so far (trimmed). Nothing spoken leaves the text as it was. */
export function mergeTranscript(base: string, spoken: string): string {
  const head = typeof base === "string" ? base.replace(/\s+$/, "") : "";
  const tail = typeof spoken === "string" ? spoken.trim() : "";
  if (tail === "") return typeof base === "string" ? base : "";
  return head === "" ? tail : head + " " + tail;
}
